import React from "react";
import { NavLink } from "react-router-dom";
import { Pages } from "../../utils/constants";
import Button from "../Basic/Button";

const CTA = () => {
  return (
    <div className="px-5 lg:px-10 py-14 lg:py-20 bg-navy -mb-1">
      <div className="w-full lg:max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-center justify-between gap-14 lg:gap-8">
        <h2 className="text-white text-3xl lg:text-4xl lg:max-w-3xl header leading-relaxed lg:leading-relaxed">
          Results that{" "}
          <span className="text-green-primary whitespace-nowrap">
            speak for themselves.
          </span>
          <br />
          Ready to supercharge your clinical team?
        </h2>

        <NavLink to={Pages.CONTACT}>
          <Button className="w-full lg:w-fit">Request demo</Button>
        </NavLink>
      </div>
    </div>
  );
};

export default CTA;
